import { Loading, Stack, Text } from 'shell/components';

const PreviewGenerating = () => {
    return (
        <Stack sx={{ position: 'relative', px: 5 }} alignItems={'center'} spacing={8}>
            <Stack alignItems={'center'} spacing={2}>
                <Text align={'center'} component={'p'} variant={'h6'} weight={'semibold'}>
                    Generating Preview
                </Text>
                <Text align={'center'}>
                    Please keep this window open until this process completes. This may take a few minutes.
                </Text>
            </Stack>
            <Loading sx={{ zoom: 0.5 }} />
        </Stack>
    );
};

export default PreviewGenerating;
